<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="edit({})">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    width="160"
                    label="封面">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 150px; height: 90px"
                            :src="scope.row.coverImg"
                            :lazy="true"
                            :preview-src="scope.row.coverImg"
                            :preview-src-list="[scope.row.coverImg]"
                            fit="fill"></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="title"
                    label="标题" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="contentFormHtml"
                    label="简介">
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="detailsFormHtml"
                    label="详情">
                </el-table-column>
                <el-table-column
                    min-width="200"
                    label="活动时间" >
                    <template slot-scope="scope">
                        {{scope.row.startTime}}-{{scope.row.endTime}}
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="200"
                    label="报名时间" >
                    <template slot-scope="scope">
                        {{scope.row.signUpStartTime}}-{{scope.row.signUpEndTime}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="240"
                >
                    <template slot-scope="scope">
                         <div class="fx fx-m_between fx-c_center">
                             <el-link type="primary" @click="editBuiltInForm(scope.row)"
                                      :underline="false" ><i class="iconfont icon-bianji"></i><b>内置表单</b></el-link>
                            <el-link type="primary" @click="edit(scope.row)"
                                                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        </div>
                        <div class="fx fx-m_between fx-c_center">
                            <el-link type="primary" @click="editUserInfo(scope.row)"
                                     :underline="false" ><i class="iconfont icon-barchart"></i><b>报名统计</b></el-link>
                            <el-popconfirm @onConfirm="remove(scope.row)"
                                           title="确认移除该数据吗？"
                            >
                                <div slot="reference" class="fx fx-center" style="position: relative;left: -5px;">
                                    <el-button type="danger" icon="el-icon-minus" circle size="mini" style="padding: 2px"></el-button>
                                     <span class="remove_btn ">移除</span>
                                </div>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <EditDraw v-if="showEdit" @submit="loadData"
             @close="showEdit=false" :item="editItem"></EditDraw>
    </div>
</template>

<style scoped>
    .remove_btn {
        padding-left: 5px;
        cursor: pointer;
        font-size: 16px;
    }
    .remove_btn:hover {
        color: var(--danger);
    }
</style>

<script>

    import EditDraw from './ActivityEditDrawer';
    import {mapState, mapMutations} from "vuex";
    export default {
        components: {
            EditDraw,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                editItem: {},
                showEdit: false,
                form: {
                    keywords: "",
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
            }
        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },
        methods: {
            ...mapMutations(["openTab"]),
            edit(item) {
                item.datesVelue = [];
                this.editItem = {...item};
                this.showEdit = true;
            },
            editUserInfo(item) {
                this.openTab({
                    funcKey: "school_page_activity_user_info_manage",
                    title: "报名统计",
                    allowDuplicate: true,
                    attr: {
                        activityId:item.id
                    }
                });
            },
            editBuiltInForm(item) {
               this.openTab({
                   funcKey: "school_page_activity_builtin_form_manage",
                   allowDuplicate: true,
                   title: "活动表单内置",
                   attr: {
                       activityId:item.id
                   }
               });
            },
            loadData() {
                this.$ajaxPost("/activity/list", {
                    form: this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showEdit = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            remove(item) {
                this.$ajaxGet("/activity/del/" + item.id, data => {
                    this.$showSuccess("保存成功");
                    this.loadData();
                })
            },
        },
        created() {
            this.loadData();
        }
    }
</script>
